import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router';
import { useData } from '@hooks/useData';
import { useGetAllDrivers } from '@services/useGetAllDrivers';

export const DriversMapSetup = () => {
    const { allSettings, login } = useData();
    const { request: fetchDrivers } = useGetAllDrivers();

    // Convert the interval from settings, minutes to milliseconds
    const intervalMinutes = Number(allSettings?.data?.locationUpdateInterval) || 0;
    const intervalMs = intervalMinutes * 60 * 1000;

    const fetchDriversRef = useRef(fetchDrivers);
    fetchDriversRef.current = fetchDrivers;

    useEffect(() => {
        if (!login || intervalMs === 0) return;

        const intervalId = setInterval(() => {
            fetchDriversRef.current();
        }, intervalMs);

        // refresh immediately when the user resumes the app, so a PWA that
        // lived in the background doesn't keep showing stale driver positions
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') fetchDriversRef.current();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [login, intervalMs]);

    return (
        <>
            <Outlet />
        </>
    );
};
